
import { Parents } from '../../src/js/_components';

var searchBlockForm = document.getElementById("search-block-form");
// Add event listener to the parent element
searchBlockForm.addEventListener("focusin", function(event) {
  // Check if the event target is an input element
  if (event.target.tagName === 'INPUT') {
      // Focus on the parent element
      searchBlockForm.classList.add("focus");
  }
});

searchBlockForm.addEventListener("focusout", function(event) {
  const parents = Parents(event.relatedTarget, searchBlockForm);
  
  if(parents === false) {
    
    searchBlockForm.classList.remove("focus");
  }
  
});